module.exports = __webpack_public_path__ + "static/media/settings-icon.6a3ae07a.svg";